export default "__VITE_ASSET__BoLz3e2Q__"